var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 5 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54834 2.95703C4.54834 1.85703 3.64834 0.957031 2.54834 0.957031C1.44834 0.957031 0.54834 1.85703 0.54834 2.95703C0.54834 4.05703 1.44834 4.95703 2.54834 4.95703C3.64834 4.95703 4.54834 4.05703 4.54834 2.95703Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54834 16.957C4.54834 15.857 3.64834 14.957 2.54834 14.957C1.44834 14.957 0.54834 15.857 0.54834 16.957C0.54834 18.057 1.44834 18.957 2.54834 18.957C3.64834 18.957 4.54834 18.057 4.54834 16.957Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54834 9.95703C4.54834 8.85703 3.64834 7.95703 2.54834 7.95703C1.44834 7.95703 0.54834 8.85703 0.54834 9.95703C0.54834 11.057 1.44834 11.957 2.54834 11.957C3.64834 11.957 4.54834 11.057 4.54834 9.95703Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuVertical);
export default __webpack_public_path__ + "static/media/menu-vertical.b37cb296e07f4f6471b4759c3a4a8bf6.svg";
export { ForwardRef as ReactComponent };